import React, { useEffect, useState } from 'react'
import * as S from './styles'

import ImageNext from '@/components/ImageNext'

import { PAGE_PATHS } from '@/services/paths'
import { EVENT_KEYS, sendToDataLayer } from '@/services/events'

import { useTranslation } from 'react-i18next'

const BannerIntro = props => {
  const { bg, bgWidth, bgHeight, title, subtitle, optionalText } = props
  const { t } = useTranslation()

  const [buttonsDemo, setButtonsDemo] = useState('Demo')

  useEffect(() => {
    setButtonsDemo(t('buttons.demo'))
  }, [t])

  const renderOptionalText = () => {
    if (!optionalText) return

    return <p>{optionalText}</p>
  }

  const requestDemoCallback = () => {
    sendToDataLayer({
      event: EVENT_KEYS.requestDemo
    })
  }

  return (
    <S.BannerIntroContainer id="banner_intro" bg={bg}>
      <div className="svg-container overlay">
        <svg
          xmlns="https://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <title>SVG Curve</title>
          <desc>Decorative curve in SVG</desc>
          <path d="M0,85 Q25,110 50,75 Q90,15 105,50" />
          Your browser does not support inline SVG.
        </svg>
      </div>

      <div className="text-container">
        <h1>{title}</h1>
        <div>
          <p>{subtitle}</p>
          {renderOptionalText()}
        </div>
        <a
          href={PAGE_PATHS.contact}
          id="btn_contact"
          className="btn orange lg"
          onClick={requestDemoCallback}
        >
          {buttonsDemo}
        </a>
      </div>

      <div className="img-container">
        <ImageNext
          src={bg}
          alt=""
          width={bgWidth}
          height={bgHeight}
          autoSize={true}
        />
      </div>
    </S.BannerIntroContainer>
  )
}

export default BannerIntro
